<template>
  <section class="artmed360 container-fluid">
    <div class="row tit-artmed360">
      <div class="col-12 text-center">
        <h1>CONHEÇA O ARTMED360</h1>
      </div>
    </div>
    <div id="artmed360">
      <div class="container">
        <div class="row justify-content-center mt-5">
          <div class="col-12 col-md-5 order-2 order-md-1">
            <img class="mb-3" :src="require('@/assets/img/logo-artmed360.svg')" alt="Artmed360">
            <p>
              A Artmed360 é um marketplace de cursos digitais voltado para
              profissionais da área da Saúde, em suas mais diversas
              especialidades. Por aqui, aliamos a tradição editorial da Artmed
              com a curadoria de conteúdos de relevância e qualidade, produzidos
              em parceria com sociedades científicas, hospitais, universidades e
              profissionais que são referência em suas áreas.
            </p>
            <p>
              O nosso objetivo é oferecer um verdadeiro hub de conhecimento,
              onde nos juntamos a grandes autores e instituições por uma mesma
              causa: aprimorar a qualidade do ensino em Saúde no Brasil. Vamos
              juntos?
            </p>
            <a href="https://www.artmed360.com.br/" target="_blank" class="btn btn-primary d-inline-flex align-items-center mt-4">
              <span>Conheça o Artmed360</span>
            </a>
          </div>
          <div class="col-12 col-md-7 order-1 order-md-2">
            <img class="pl-md-3 mb-3" :src="require('@/assets/img/tela-artmed360.png')" alt="Captura de tela do site Artmed360">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Artmed360View'
}
</script>
